import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomRedoAiMappingRunAreaMutation } from "generated/graphql";

export const useRedoAiMappingRunArea = () => {
  const [mutation, { data, loading, error }] = useCustomRedoAiMappingRunAreaMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "redoAiMappingRunArea" },
    { hideMessage: true }
  );
};
